import React from 'react';
import { Loan } from '../types/loan.types';
import { DocumentSlot } from './DocumentSlot';
interface DocumentsTabProps {
  loan: Loan;
  onDocumentUpload: (documentId: string, file: File, fileName: string) => void;
}
export function DocumentsTab({
  loan,
  onDocumentUpload
}: DocumentsTabProps) {
  const completedDocs = loan.requiredDocuments.filter(doc => doc.status !== 'missing').length;
  const totalDocs = loan.requiredDocuments.length;
  return <div className="space-y-6" data-id="element-45">
      <div className="flex items-center justify-between" data-id="element-46">
        <div data-id="element-47">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-48">
            Required Documents
          </h3>
          <p className="text-sm text-gray-600 mt-1" data-id="element-49">
            Upload all required documents to complete this loan application
          </p>
        </div>
        <div className="text-right" data-id="element-50">
          <div className="text-2xl font-bold text-gray-900" data-id="element-51">
            {completedDocs}/{totalDocs}
          </div>
          <div className="text-xs text-gray-500" data-id="element-52">Completed</div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-53">
        {loan.requiredDocuments.map(doc => <DocumentSlot key={doc.id} document={doc} onUpload={onDocumentUpload} data-id="element-54" />)}
      </div>
    </div>;
}